export const PanelTypes = {
    BASIC : 'basic',
    USER : 'user',
    SIDEBAR : 'sidebar',
};

export const ItemTypes = {
    MODULE: 'module',
};

export const ModuleTypes = {
    NORMAL : 'normal',
    PLUGIN : 'plugin',
    AD : 'ad',
}
